export default () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.38995 15.5899C6.84321 16.1367 5.95679 16.1367 5.41005 15.5899C4.86332 15.0432 4.86332 14.1568 5.41005 13.61L11.0101 8.01005C11.5568 7.46332 12.4432 7.46332 12.9899 8.01005L18.5899 13.61C19.1367 14.1568 19.1367 15.0432 18.5899 15.5899C18.0432 16.1367 17.1568 16.1367 16.6101 15.5899L12 10.9799L7.38995 15.5899Z"
      fill="currentColor"
    />
  </svg>
);
